
namespace Matrix.Scheduling {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CalendarDialog extends SiteEntityDialog<CalendarRow, any> {
        protected getFormKey() { return CalendarForm.formKey; }
        protected getIdProperty() { return CalendarRow.idProperty; }
        protected getLocalTextPrefix() { return CalendarRow.localTextPrefix; }
        protected getNameProperty() { return CalendarRow.nameProperty; }
        protected getService() { return CalendarService.baseUrl; }
        protected getDeletePermission() { return CalendarRow.deletePermission; }
        protected getInsertPermission() { return CalendarRow.insertPermission; }
        protected getUpdatePermission() { return CalendarRow.updatePermission; }

        protected form = new CalendarForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.CalendarEntries.calendarCode = this.entityId;
            this.updateInterface();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 280;
            this.form.CalendarEntries.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.CalendarEntries.set_readOnly(this.form.CalendarEntries.get_readOnly() || this.isNew());
        }
    }
}